// @ts-nocheck

import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 12px 0;
    background: #540074;
    border-radius: ${theme.border.radius.medium};
    text-align: center;
    margin-bottom: ${theme.spacing.stack.xxxs};

    @media (min-width: 768px) and (max-width: 1170px) {
      ${({ theme }) => css`
        padding: ${theme.spacing.stack.xxxs} 0;
        text-align: center;
      `}
    }

    @media (min-width: 1171px) {
      ${({ theme }) => css`
        padding: ${theme.spacing.stack.xxxs} 0;
        text-align: center;
      `}
    }
  `}
`

export const Title = styled.p`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: ${theme.color.neutral.nth4};

    @media (min-width: 768px) and (max-width: 1170px) {
      font-size: ${theme.font.size.md};
      line-height: ${theme.spacing.stack.sm};
    }
  `}
`
